import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: {
      "name": "Name",
      "account": "Account",
      "amount": "Amount",
      "purposeCode": "Transfer code",
      "reason": "Reason",
      "debitRecall": "Debit recall",
      "creditRecall": "Credit recall",
      "payerAccount": "Payer account",
      "code": "Code",
      "program": "Program",
      "priority": "Priority",
      "orderType": "Order type",
      "cancel": "Cancel",
      "ok": "Ok",
      "transfer": "Transfer",
      "action": "Action",
      "loadFile": "Load file",
      "addTransfer": "Add transfer",
      "generateFile": "Generate file",
      "other": "Other",
      "international": "International",
      "address": "Address",
      "chargeType": "Charge type",
      "swiftCode": "Swift code",
      "mustBeNumber": "Only numbers are allowed for this field",
      "mustBeDecimal": "Only decimals are allowed for this field",
      "mustBeDecimal_DecimalCount": "Only decimals are allowed for this field. Max number of decimals: {{decimals}}",
      "fileErrorTitle": "File upload error",
      "fileErrorIncorrectFormat": "File does not have the correct format",
      "fileErrorIncorrectContent": "Please review the content of your file. Every line should contain exactly {{columnSize}} columns"
    }
  },
  mk: {
    translation: {
        "name": "Назив",
        "account": "Сметка",
        "amount": "Износ",
        "purposeCode": "Шифра на плаќање",
        "reason": "Цел на дознака",
        "debitRecall": "Повикување на број (налогодавач)",
        "creditRecall": "Повикување на број (примач)",
        "payerAccount": "Сметка на налогодавач",
        "code": "Шифра на плаќање",
        "program": "Програма",
        "priority": "МИПС (итно)",
        "orderType": "Тип",
        "cancel": "Откажи",
        "ok": "Ok",
        "transfer": "трансфер",
        "action": "Aкција",
        "loadFile": "Bчитаjte датотека",
        "addTransfer": "Додадете Tрансфер",
        "generateFile": "Генерирајте датотека",
        "other": "Друго",
        "international": "Меѓународен",
        "address": "Адреса",
        "chargeType": "Тип на трошок",
        "swiftCode": "SWIFT код"
    }
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

  export default i18n;